import { gql } from "@apollo/client"
import { apolloClient } from "../../apollo"

export const getOpdQueryBuilder = (metrics, dimension, isTotal) => {
    const dimensionStr = `dimensions { 
        ${dimension} 
    }`
    const dimensionQuery = isTotal ? `` : dimensionStr

    return `federatedMetricValues(
                input: {
                    attributeFilters: [
                        {
                            attribute: "DIMENSION"
                            name: "${dimension}"
                            values: $ids
                        }
                        {
                            attribute: "DIMENSION"
                            name: "channel"
                            values: $channel
                        }
                    ]
                    timeFilters: [
                        {
                            startDate: $startDate
                            endDate: $endDate
                        }
                    ]  
                }
            ) { 
                opd {
                    edges {
                        node {
                            ${dimensionQuery}
                            metrics {
                                ${metrics.join(`
                                `)}
                            }
                        }
                    }
                }
            }`
}

export const getOpdQuery = (metrics, dimension, isTotal) => {
    const opdQueryBuilder = getOpdQueryBuilder(metrics, dimension, isTotal)
    const query = `query federatedMetricValues($startDate: String!, $endDate: String!, $ids: [String], $dimension: String!, $channel: [String]) {
            ${opdQueryBuilder}
        }`
    return query
}

export const getOpdMetrics = (metrics, dimension, ids, payload, isTotal) => {
    const obj = {
        ...payload,
        ids: ids,
        dimension: dimension,
        channel: ['STORE']
    }

    const query = gql`${getOpdQuery(metrics, dimension, ids, isTotal)}`;

        return apolloClient.query({
            query,
            context: {
                headers: {
                    'x-Apollo-operation-name': "federatedMetricValues"
                }
            },
            variables: obj
        })

}